import { render, staticRenderFns } from "./FederalCreate.vue?vue&type=template&id=278841a8&scoped=true&"
import script from "./FederalCreate.vue?vue&type=script&lang=js&"
export * from "./FederalCreate.vue?vue&type=script&lang=js&"
import style0 from "./FederalCreate.vue?vue&type=style&index=0&id=278841a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278841a8",
  null
  
)

export default component.exports